module.exports = __webpack_public_path__ + "files/873c4e80e3bf4f1168530d1bbfa9d175.png";